/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsCustomSacSendViewProps } from './hosports-custom-sac-send';

export default (props: IHosportsCustomSacSendViewProps) => {
    return (
        <h2>{'Custom Sac Send'}</h2>
    );
};
